//#region [IMPORT]

// === THIRD-PARTY ===
import React, {  } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import {
  Check,
} from '@mui/icons-material';

//#endregion

//-----------------------------------------------------------------
export function AutoOption() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme        = useTheme();

  const setting_task_submit = localStorage.getItem( 'setting-task-submit' );

  const _is_active = setting_task_submit === '1' ? '' : 'hidden';
  const _icon      = <Check sx={{visibility: _is_active }} />;
  const _text      = 'Auto';
  
  const _hover_theme = theme.palette.mode === 'light' ? 'secondary' : 'primary';

  const is_light = theme.palette.mode === 'light';

  const _styles = {
    container: {
      display    : 'flex'   ,
      marginLeft : 'auto'   ,
      alignItems : 'center' ,
      padding    : '0.5rem' ,
      cursor     : 'pointer',

      '&:hover': {
        background: theme.palette.background[_hover_theme][theme.palette.mode],
      },
    },
    icon: {
      color: is_light ? theme.palette.primary.main : '',
    },
    text: {
      paddingLeft: '0.5rem',
    }
  }

  //#endregion

  //#region [MODIFY]

  //-----------------------------------------------------------------
  function toggle() {
    //-----------------------------------------------------------------
    localStorage.setItem('setting-task-submit', 1 );
  }
  
  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
      return (
        <Box sx={_styles.container} onClick={toggle}>
          {_icon}
          <Box sx={_styles.text}> {_text} </Box>
        </Box>
      );
  }

  //#endregion

  return display();
}